import React, { useCallback } from 'react';
import classNames from 'classnames';
import { FieldRenderProps } from 'react-final-form';
import CheckToggle from 'components/CheckToggle/CheckToggle.component';
import FieldWrapper from 'components/FieldWrapper';
import { FieldWrapperProps } from 'components/FieldWrapper/FieldWrapper.component';

import './CheckToggleField.styles.scss';

type CheckToggleFieldProps = {
  customOnChange?: (value: boolean) => void;
} & FieldWrapperProps &
  FieldRenderProps<boolean, HTMLElement>;

const CheckToggleField: React.FC<CheckToggleFieldProps> = (props) => {
  const {
    children,
    className,
    input: { value, checked, onChange, ...restInput },
    meta,
    onContent,
    offContent,
    id,
    customOnChange,
    ...rest
  } = props;

  const classes = classNames('check-toggle-field', className);

  const handleOnChange = useCallback(
    ({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) => {
      onChange(checked);
      customOnChange?.(checked);
    },
    [customOnChange, onChange],
  );

  return (
    <FieldWrapper className={classes} {...rest}>
      <CheckToggle
        checked={checked}
        onChange={handleOnChange}
        {...restInput}
        {...rest}
      />
    </FieldWrapper>
  );
};

export default CheckToggleField;
